export const MANAGED_QUEUE_FILTER="((queueType==INBOUND),((queueType==OUTBOUND);(channelType=out=(SOCIAL_CHANNEL,EMAIL))));(active==true)";